
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'MainLogo'
})
export default class MainLogo extends Vue {}
